import {isMobile} from '@tfx/common/utils/responsive'
import {createStore} from '@tfx/common/initializers'

const state = {
  storing: false,
  isMobile
}

const getters = {
  getAllowEditing: (state, getters, rootGetters) => {
    return getters['questionnaireModule/getAllowEditing']
  },
  isShowNumbers: state => true,
  isMobile: state => state.isMobile.value
}

const mutations = {}

const actions = {
  showErrorDialog: ({state, dispatch}, {errors}) => {
    dispatch('dialogs/showModal', {currentProperties: {errors: errors}, dialogType: 'errors-dialog'})
  },
  // FIXME this is temporary
  questionAnswerChanged ({dispatch}, question) {
    store.dispatch('questionnaireModule/question_answer_changed', question)
  },
  startStore: ({state}) => {
    state.storing = true
  },
  stopStore: ({state}) => {
    state.storing = false
  }
}

import authorization from './modules/authorization/store'
import geoLocation from './modules/geolocation/store'
import dialogs from './modules/dialogs/index'
import confirmation from './modules/documents/confirmations'
import clientDiligences from './modules/client-diligences/store'
import clientCpaErrors from './modules/admin/client_cpa_errors'
import clientCounters from './modules/client-counters/store'
import confirmationPopup from './modules/confirmation-popup/store'
import adminSidebar from './modules/admin/sidebar'

export const store = createStore({
  state,
  getters,
  actions,
  mutations,
  modules: {
    authorization: authorization,
    geoLocation: geoLocation,
    confirmationPopup: confirmationPopup,
    document_confirmations: confirmation,
    dialogs: dialogs,
    clientDiligence: clientDiligences,
    adminClientCpaErrors: clientCpaErrors,
    clientCounters: clientCounters,
    admin: {
      namespaced: true,
      modules: {
        sidebar: adminSidebar
      }
    }
  }
})
